import script from "./UploadClassificationsExcel.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadClassificationsExcel.vue?vue&type=script&setup=true&lang=js"

export default script